<template>
  <v-dialog v-model="dialog" max-width="1200px">
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-icon>compare</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title>
        <span class="text-h5">Change Compare</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row justify="center">

            <v-col cols="5">
                <b>Before</b>
                <div id="content-before" style="overflow: auto; height:400px; width:500px;">
                  <pre><span><br/></span>{{formattedContentBefore}}</pre>
                </div>
            </v-col>

            <v-spacer>
            </v-spacer>

            <v-col cols="5">
                <b>After</b>
                <div id="content-after" style="overflow: auto; height:400px;  width:500px;">
                  <pre>
                    <span v-for="line in formattedContentAfter"
                      :key="line.text"
                      :style="line.style">
{{line.text}}</span>
                  </pre>
                </div>
            </v-col>

          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn id="okButton" color="primary" @click="reset">
            OK
          </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from 'vue';
import {
  Component, Prop, Watch,
} from 'vue-property-decorator';

const jsdiff = require('diff');

@Component({
})
export default class AuditMessageCompareDialog extends Vue {
  @Prop()
  contentBefore!: string;

  @Prop()
  contentAfter!: string;

  formattedContentBefore: string|null = null;

  formattedContentAfter: DisplayLine[] = [];

  dialog:boolean = false;

  loading = false;

  @Watch('dialog')
  onDialogToggle() {
    if (this.dialog) {
      this.loading = true;
      this.formattedContentBefore = this.getFormattedContentBefore();
      this.formattedContentAfter = this.getFormattedContentAfter();
      this.loading = false;
    }
  }

  getFormattedContentBefore() {
    return this.contentBefore
      ? JSON.stringify(JSON.parse(this.contentBefore), null, '\t')
      : null;
  }

  getFormattedContentAfter() {
    return this.fancyStringDiff(this.contentBefore, this.contentAfter);
  }

  fancyStringDiff(oldString: string, newString: string) {
    const oldJson = JSON.stringify(JSON.parse(oldString), null, '\t').split('\n');
    const newJson = JSON.stringify(JSON.parse(newString), null, '\t').split('\n');

    const diff : Diff[] = jsdiff.diffJson(oldJson, newJson);

    const result: DisplayLine[] = [];
    diff.forEach((part) => {
      // green for additions, red for deletions
      part.value.split('\n').forEach((rawLine) => {
        const line = rawLine.trim();

        if (line === '[' || line === ']') {
          return;
        }
        const displayLine: DisplayLine = { style: '', text: '' };
        if (part.added) {
          displayLine.style = 'background-color: #c2f7c2';
        } else if (part.removed) {
          if (line.length === 0 || line.trim() === '"null"' || line.trim().length === 0) {
            return;
          }
          displayLine.style = 'background-color: #f7bac6';
        } else {
          displayLine.style = '';
        }
        if (line.length === 0) {
          return;
        }
        displayLine.text = this.convertCharacterSequences(line);
        result.push(displayLine);
      });
    });

    return result;
  }

  convertCharacterSequences = (inputString: string) => {
    let result = inputString.trim();
    result = result.replace(/\\t/g, '\t');
    result = result.replace(/\\"/g, '"');
    result = result.replace(/^"/, '');
    result = result.replace(/",$/, '');
    result = result.replace(/^}"$/, '}');
    return result;
  }

  reset() {
    this.dialog = false;
    this.formattedContentBefore = null;
    this.formattedContentAfter = [];
  }
}

interface Diff {
    count: number,
    added: boolean|undefined,
    removed: boolean|undefined,
    value: string,
}

interface DisplayLine{
  style: string,
  text: string,
}

</script>

<style lang="scss" scoped>
</style>
